import React from 'react'
import {CreateIncidents} from 'components/pages/StatusPage/Incidents/CreateIncidents'
import {CreateMaintainance} from 'components/pages/StatusPage/Maintainance/CreateMaintainance'
import {CreateComponents} from 'components/pages/StatusPage/ServiceComponents/CreateComponents'
import {CreateTemplates} from 'components/pages/StatusPage/Settings/Templates/CreateTemplates'
import {STATUS_PAGE_PATH} from 'constants/path'
import StatusPageLayout from 'layouts/StatusPage.layout'

const statusPageRoutes = [
  {
    path: STATUS_PAGE_PATH.PREFIX,
    element: <StatusPageLayout />,
    handle: {title: 'Status Page'},
    children: [
      {index: true, lazy: () => import('components/pages/StatusPage/Statuspageoption')},
      {
        path: STATUS_PAGE_PATH.INCIDENTS,
        handle: {title: 'Incidents'},
        lazy: () => import('components/pages/StatusPage/Incidents/Incidents'),
      },
      {
        path: `${STATUS_PAGE_PATH.INCIDENTS}/:incidentsId`,
        handle: {title: 'Incidents'},
        element: <CreateIncidents />,
      },
      {
        path: STATUS_PAGE_PATH.MAINTENANCE,
        handle: {title: 'Maintenance'},
        lazy: () => import('components/pages/StatusPage/Maintainance/Maintainance'),
      },
      {
        path: `${STATUS_PAGE_PATH.MAINTENANCE}/:maintenanceId`,
        handle: {title: 'Maintenance'},
        element: <CreateMaintainance />,
      },
      {
        path: STATUS_PAGE_PATH.SERVICE_COMPONENTS,
        handle: {title: 'Service Components'},
        lazy: () => import('components/pages/StatusPage/ServiceComponents/Servicecomponents'),
      },
      {
        path: `${STATUS_PAGE_PATH.SERVICE_COMPONENTS}/:id/service`,
        handle: {title: 'Service Components'},
        element: <CreateComponents />,
      },
      {
        path: `${STATUS_PAGE_PATH.SERVICE_COMPONENTS}/:id/group`,
        handle: {title: 'Service Components'},
        element: <CreateComponents />,
      },
      {
        path: STATUS_PAGE_PATH.CUSTOMIZATION,
        handle: {title: 'Customization'},
        lazy: () => import('components/pages/StatusPage/Customization/Customization'),
      },
      {
        path: STATUS_PAGE_PATH.MANAGE_SUBSCRIBERS,
        handle: {title: 'Manage Subscribers'},
        lazy: () => import('components/pages/StatusPage/Subscribers/ManageSubscribers'),
      },
      {
        path: STATUS_PAGE_PATH.GENERAL,
        handle: {title: 'General'},
        lazy: () => import('components/pages/StatusPage/Settings/General'),
      },
      {
        path: STATUS_PAGE_PATH.STATUS_EMBED,
        handle: {title: 'Status Embed'},
        lazy: () => import('components/pages/StatusPage/Settings/Statusembed'),
      },
      {
        path: STATUS_PAGE_PATH.TEMPLATES,
        handle: {title: 'Templates'},
        lazy: () => import('components/pages/StatusPage/Settings/Templates/Templates'),
      },
      {
        path: `${STATUS_PAGE_PATH.TEMPLATES}/:id`,
        handle: {title: 'Templates'},
        element: <CreateTemplates />,
      },
      {
        path: STATUS_PAGE_PATH.INCIDENT_SOURCES,
        handle: {title: 'Incident Sources'},
        lazy: () => import('components/pages/StatusPage/Settings/IncidentSource/IncidentSource'),
      },
      {
        path: STATUS_PAGE_PATH.INCIDENT_STATUS,
        handle: {title: 'Incident Status'},
        lazy: () => import('components/pages/StatusPage/Settings/IncidentStatus/IncidentStatus'),
      },
    ],
  },
]

export default statusPageRoutes
